import api from '@/api'
import types from '@/types'
import Report, { UnsupportedMediaTypeReport } from '@/api/communique/report'

export interface BroadcastDelivery {
  // the number of impressions for a specific device
  allimpressions: number

  //orderaqh

  ordered_impressions: number

  over_delivery: number

  over_delivery_percentage: number

  // the type of the device
  stations: String
}

export interface FetchBroadcastDeliveryParams {
  startDate?: string
  endDate?: string
  initiativeId?: string
  mediaTypes: string[]
  excludeLineItemIds?: string[]
  includeLineItemIds?: string
  station: String[] | null
}

export class CampaignBroadcastDelivery {
  public async fetchAll({
    initiativeId,
    mediaTypes,
    endDate,
    excludeLineItemIds,
    includeLineItemIds,
    startDate,
    station,
  }: FetchBroadcastDeliveryParams): Promise<Report<BroadcastDelivery> | UnsupportedMediaTypeReport> {
    return api('report.dashboards.ihmCampaign.v2.campaignBroadcastDelivery')
      .params({
        initiativeId,
        media_types: mediaTypes,
        end_date: endDate,
        start_date: startDate,
        exclude_line_item_ids: excludeLineItemIds,
        include_line_item_ids: includeLineItemIds,
        station: station,
      })
      .cache(1000 * types.config.dashboardCacheSeconds())
      .jsonMust<Report<BroadcastDelivery>>()
  }
}
